import { makeStyles } from "@material-ui/core"
import React from "react"
import { ActionCard } from "."
import { AuthorTools } from "../Author"
import { ColumnBox, RowBox } from "../Boxes"
import { Icon } from "../Icon"

const useStyles = makeStyles((theme) => ({
  paused: {
    border: `1px solid ${theme.palette.scheduled.main}`,
  },
  tick: {
    color: theme.palette.success.main,
  },
}))

const IntegrationActionCard = ({ integration, onEdit, detail, loading, ...rest }) => {
  const classes = useStyles()
  const {
    id,
    paused,
    integrationProvider: { name, description },
  } = integration

  const handleEdit = () => {
    onEdit && onEdit(integration)
  }

  return (
    <ActionCard
      key={id}
      title={name}
      detail={description || "Integration"}
      cursor={null}
      stub={
        <ColumnBox mr={1} justifyContent="flex-start">
          {!paused && <Icon name="tick" className={classes.tick} />}
          {paused && <Icon name="integration" />}
        </ColumnBox>
      }
      completed={!paused}
      isScheduled={paused}
      className={paused ? classes.paused : null}
      rightChildren={
        <RowBox alignItems="flex-start">
          <AuthorTools
            icon="configure"
            item={integration}
            admins={{
              edit: "integration_update",
            }}
            editLabel="Configure"
            onEdit={handleEdit}
            subject="integration"
            disabled={loading}
          />
        </RowBox>
      }
      {...rest}
    />
  )
}

export { IntegrationActionCard }
